<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <template v-if="verContenido">
      <v-row dense>
        <v-col cols="12">
          <ButtonComp @click="cerrarmodal" text-button="Volver" class-color="red" icon-but="fas fa-arrow-alt-circle-left"
            normal-button />
        </v-col>
        <v-col cols="12" class="d-flex">
          <v-chip label>
            Tema : {{ dataContenido.nombre_clase }}
          </v-chip>
          <v-spacer />
          <ButtonComp @click="VisorDiapositivas(dataContenido)" text-button="Visualizar" icon-but="fas fa-eye"
            class-color="green" normal-button />
          <ButtonComp @click="CrearDiapositiva(dataContenido)" text-button="Crear diapositivas" icon-but="fas fa-plus"
            class="mx-2" normal-button />
        </v-col>

        <v-col cols="12">
          <v-alert type="warning" class="ml-2 mr-2" v-if="listContenidos.length < 1">
            <strong>Aún no tiene diapositivas creadas en este tema.</strong>
          </v-alert>
          <ComundataTablecomp :headers="ListdiapositivaHeaders" v-sortable :items="listContenidos">
            <template v-slot:tipo="{ item }">
              <span v-if="item.tipo === 'DS'">CONTENIDO</span>
            </template>

            <template v-slot:fecha="{ item }">
              {{ item.fec_us_ing | filtroFecha }}
            </template>

            <template v-slot:edit="{ item }">
              <ButtonComp @click="EditarDiapositiva(item)" v-if="item.tipo == 'DS'" editButton
                tooltipText="Editar diapositiva" />
            </template>

            <template v-slot:delete="{ item }">
              <ButtonComp @click="ShowConfirmDeleteDiapositiva(item)" deleteButton tooltipText="Borrar diapositiva" />
            </template>
          </ComundataTablecomp>
        </v-col>

      </v-row>

    </template>

    <!-- confim para eliminar diapositiva -->
    <Confirm title="¿Estás seguro que desea eliminar esta diapositiva?" :active="confirmDeleteDiapositiva"
      @aceptar="DeleteDiapositiva" @cancelar="CloseConfirmDeleteDiapositiva" />

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal">
    </component>
  </div>
</template>


<script>
import axios from "@/helpers/axios";
import { mapMutations } from "vuex";
import BtnComp from "@/components/ComponentsEst/BtnComp.vue";

import Confirm from "@/components/confirm";
import VisorContenido from "@/views/Manager/GestionContenido/viewGC/visorGestorContenido";
import GCDiapositiva from "./gcDiapostiva/gestorDiapositiva";
import GCpregPU from "./gcPregunta/pregPU";
import GCpregPM from "./gcPregunta/pregPM";
import GCpregPV from "./gcPregunta/pregPV";
import Sortable from "sortablejs";
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';

import { ListdiapositivaHeaders } from '../../../../helpers/headersTable';

export default {
  name: "Contenido",
  // componentes
  components: {
    ButtonComp,
    ComundataTablecomp,
    Confirm,
    VisorContenido,
    GCDiapositiva,
    GCpregPU,
    GCpregPM,
    GCpregPV,
    BtnComp,
  },

  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },

  data() {
    return {
      mensaje: { tipo: null, mensaje: null, tiempo: null }, // mensaje de sistema

      // componente
      compName: null,
      estadoComponente: false,
      parametroComp: [],
      test: false,
      ListdiapositivaHeaders,

      verContenido: true,

      dataContenido: {},
      listContenidos: [],

      confirmDeleteDiapositiva: false,
      diapositivaDelete: "",


    };
  },

  directives: {
    sortable: {
      bind(el, binding, vnode) {
        const sortableList = el.querySelector("tbody");

        const options = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit("sorted", event);
          },
        };
        // Sortable.create(el.getElementsByTagName("tbody")[0], options);
        Sortable.create(sortableList, options);
      },
    },
  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    estadoComp() {
      if (this.estadoComp) {
        this.verContenido = true;
        this.LoadMain();
      } else {
        //this.parametros = {}
        this.verContenido = false;
        this.LimpiarForm();
      }
    },
  },

  mounted() {
    this.LoadMain();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-- cargar Parametros de inicio del componente --
    async LoadMain() {
      this.dataContenido = this.parametros.item;
      this.GetAllContenidos(this.parametros.item);
    },
    ///////////////////////////////////////////////////////////

    async GetAllContenidos(item) {
      try {
        const response = await axios.get(
          `/manager/contenido/list/${item.id_clase}`,
          {
            headers: {
              "Content-Encoding": "gzip",
            },
          }
        );
        this.listContenidos = response.data.payload;
      } catch (error) {
        console.log(error);
      }
    },

    CrearDiapositiva(item) {

      this.verContenido = false;
      let data = { ...this.dataContenido, ...item };

      this.parametroComp = { evento: "agregar", item: data };
      this.compName = "GCDiapositiva";
      this.estadoComponente = true;
    },

    EditarDiapositiva(item) {
      let data = { ...this.dataContenido, ...item };
      this.verContenido = false;
      this.verSelector = false;
      this.parametroComp = { evento: "editar", item: data };
      this.compName = "GCDiapositiva";
      this.estadoComponente = true;
    },

    VisorDiapositivas(item) {

      const datosMiniatura = Object.assign(item, {
        evento: "agregar",
        miniatura: true,
        id_diapositiva: 1,
        tipo_contenido: "manager",
        // SE LE INDICA EL TIPO PARA TRAER EL CONTENIDO, EN ESTE CASO MANAGER
      });
      this.compName = "VisorContenido";
      this.estadoComponente = true;
      this.parametroComp = datosMiniatura;
    },

    CloseModal() {
      this.estadoComponente = false;
      this.verContenido = true;
      this.LoadMain();
    },

    LimpiarForm() { },

    ShowConfirmDeleteDiapositiva(item) {

      console.log(item);

      this.confirmDeleteDiapositiva = true;
      this.diapositivaDelete = item.diapositiva.id;
    },

    async DeleteDiapositiva() {
      try {
        const resp = await axios.put(
          "/manager/contenido/detd/inac/" + this.diapositivaDelete
        );
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: `${resp.data.message}`,
          tiempo: null,
        });
        this.CloseConfirmDeleteDiapositiva();
        this.LoadMain();
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Ha ocurrido un error , por favor intente nuevamente`,
          tiempo: null,
        });
      }
    },

    CloseConfirmDeleteDiapositiva() {
      this.confirmDeleteDiapositiva = false;
      this.diapositivaDelete = "";
    },
    cerrarmodal() {
      document.documentElement.style.overflow = "auto";
      this.$emit("close");
    },
  },
};
</script>

